import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"

export const validateSetupToken = createAsyncThunk('password/validateSetupToken', async (token, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/password-setup/validate`, { token })
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

// Carries the status alongside the message because the page must tell "the link is spent" (403,
// retire the form) from "the write failed" (5xx or no response, the link is still good and the
// user must be able to try again).
export const changePassword = createAsyncThunk('password/changePassword', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/update-password`, data)
    return response.data
  } catch (error) {
    return rejectWithValue({
      message: normalizeError(error),
      status: error.response?.status ?? null,
    })
  }
})

export const completePasswordReset = createAsyncThunk('password/completePasswordReset', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/password-setup/reset`, data)
    return response.data
  } catch (error) {
    return rejectWithValue({
      message: normalizeError(error),
      status: error.response?.status ?? null,
    })
  }
})

export const resendSetupLink = createAsyncThunk('password/resendSetupLink', async (email, { rejectWithValue }) => {
  try {
    const response = await apiRequest.post(`/password-setup/resend`, { email })
    return response.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
